import React from 'react';
export function Footer() {
  return <footer className="bg-rugby-green-950 py-10 md:py-16 border-t border-rugby-green-800" data-id="element-200">
      <div className="container mx-auto px-4 text-center" data-id="element-201">
        <div className="mb-4 md:mb-8" data-id="element-202">
          <h2 className="text-2xl md:text-3xl font-display text-white tracking-widest mb-1 md:mb-2" data-id="element-203">
            🏉 RUGBY PRO KIT™
          </h2>
          <p className="text-rugby-gold-400 font-medium text-sm md:text-base" data-id="element-204">
            El sistema de desarrollo N°1 para el rugbier argentino.
          </p>
        </div>

        <p className="text-slate-400 text-sm md:text-base max-w-xl mx-auto mb-6 md:mb-12 italic" data-id="element-205">
          Porque llegar a primera y al seleccionado provincial no debería
          costarte años de frustración y errores evitables.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 md:gap-8 text-sm md:text-base text-slate-300 mb-6 md:mb-12" data-id="element-206">
          <a href="mailto:contacto@rugbyprokit.com.ar" className="hover:text-rugby-gold-400 transition-colors" data-id="element-207">
            📧 contacto@rugbyprokit.com.ar
          </a>
          <a href="#" className="hover:text-rugby-gold-400 transition-colors" data-id="element-208">
            📱 @rugbyprokit.ar
          </a>
          <a href="#" className="hover:text-rugby-gold-400 transition-colors" data-id="element-209">
            🌐 rugbyprokit.com.ar
          </a>
        </div>

        <div className="text-slate-500 text-xs md:text-sm" data-id="element-210">
          © Rugby Pro Kit™ 2025 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}